export default import.meta.ROLLUP_FILE_URL_2$LtLFQdS6IeO$uJxLxRJQ;